import { useQueries } from '@tanstack/react-query';

import { isWorking } from '../constants/conversation';
import { agentRunOptions, useAgentDraft } from '../models/queries';

const jobOf = (run) => ({
	id: `agent-${run.id}`,
	jobType: 'aiAssistant',
	label: `KI-Assistent: ${run.defaultName || 'Entwurf'}`,
	status: 'running',
	indeterminate: true,
});

/**
 * What the lead page shows of the assistant outside the popup: the draft (badge on
 * "Neue Suche") and one job-strip entry per conversation that works while its chat is not on
 * screen — the draft and every saved conversation the user continued ("Mit Assistent
 * fortsetzen") in this session and then closed or switched away from.
 *
 * @param {object} params
 * @param {string[]} params.watchedRunIds - The saved conversations continued in this session
 * @param {string|null|undefined} params.visibleRunId - The conversation whose chat is on screen:
 *   a run id, `'draft'` for the draft, null when no chat is on screen
 * @returns {{draft: object|null|undefined, extraJobs: Array<object>}}
 */
export function useAssistantJobs({ watchedRunIds, visibleRunId }) {
	const { data: draft } = useAgentDraft();
	const watched = useQueries({
		queries: watchedRunIds.map((runId) => agentRunOptions(runId, { poll: true })),
		combine: (results) => results.map((result) => result.data).filter(Boolean),
	});
	const onScreen = visibleRunId === 'draft' ? draft?.id : visibleRunId;
	const runs = [draft, ...watched.filter((run) => run.id !== draft?.id)];
	const extraJobs = runs.filter((run) => run && isWorking(run.status) && run.id !== onScreen).map(jobOf);
	return { draft, extraJobs };
}
